import React from 'react'

import ChartLayout from '../../models/chart_layout'
import { useAutoSaveNote } from '../autosave/use-auto-save-note'

interface Props {
  chartLayoutModel: ChartLayout
  ideaNoteRef?: React.RefObject<HTMLTextAreaElement>
}

export function ChartLayoutAutoSaveNote({ chartLayoutModel, ideaNoteRef }: Props) {
  const { onNoteChange, activeNote, isAutoSaveActive } = useAutoSaveNote(chartLayoutModel)

  const ideaNote = chartLayoutModel.idea?.note
  const hasIdeaNote = chartLayoutModel.idea?.note !== undefined
  const noteText = isAutoSaveActive ? activeNote : ideaNote

  const handleIdeaNoteChange = React.useCallback(
    (note: string) => {
      if (chartLayoutModel.idea?.note !== note) {
        chartLayoutModel.updateAttribute('idea', { ...chartLayoutModel.idea, note })
      }
    },
    [chartLayoutModel]
  )

  React.useEffect(() => {
    const note = chartLayoutModel.idea?.note
    if (isAutoSaveActive && note) {
      onNoteChange(note)
    }
    // We want to trigger the effect only on isAutoSaveActive change
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAutoSaveActive])

  React.useEffect(() => {
    if (isAutoSaveActive && activeNote) {
      handleIdeaNoteChange(activeNote)
    }
  }, [isAutoSaveActive, activeNote, handleIdeaNoteChange])

  if (!hasIdeaNote) {
    return null
  }

  return (
    <div className="mb-4 text-xs">
      <div>Note:</div>
      <textarea
        ref={ideaNoteRef}
        className="block h-14 border border-gray-300 py-0.5 px-1"
        data-testid="idea-note-textarea"
        style={{ width: chartLayoutModel.width }}
        value={noteText}
        onChange={(e) => {
          const note = e.target.value
          handleIdeaNoteChange(note)
          if (isAutoSaveActive) {
            onNoteChange(note)
          }
        }}
      />
    </div>
  )
}
